export default "__VITE_ASSET__DrJsfM8r__"